import { RFID_FILE_DELETE_REQUEST, RFID_FILE_DELETE_SUCCESS, RFID_FILE_DELETE_FAILURE } from './types/RfidDeleteActionsTypes';

export function deleteRfidFileRequestActionCreator(selectedIds) {
  return {
    type: RFID_FILE_DELETE_REQUEST,
    payload: {
      params: {
        fileIds: selectedIds,
      },
    },
  };
}

export function deleteRfidFileSuccessActionCreator(data) {
  return {
    type: RFID_FILE_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteRfidFileFailureActionCreator(error) {
  return {
    type: RFID_FILE_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
